import { render, staticRenderFns } from "./GlobalPreferences.vue?vue&type=template&id=724823cd&"
import script from "./GlobalPreferences.vue?vue&type=script&lang=js&"
export * from "./GlobalPreferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/akryum/Projects/vue-devtools/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('724823cd')) {
      api.createRecord('724823cd', component.options)
    } else {
      api.reload('724823cd', component.options)
    }
    module.hot.accept("./GlobalPreferences.vue?vue&type=template&id=724823cd&", function () {
      api.rerender('724823cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@vue-devtools/app-frontend/src/views/settings/GlobalPreferences.vue"
export default component.exports